import { Button, ButtonProps } from "@mui/material";
import * as React from "react";
import "./styles.scss";

const classNameBase = "scd-button";

export default function CustomButton(
  props: ButtonProps & { kind?: ButtonProps["color"] },
): React.JSX.Element {
  const {
    disabled,
    type,
    kind = "primary",
    children,
    onClick,
    ...other
  } = props;

  const buttonClassName = disabled
    ? `${classNameBase}-disabled`
    : `${classNameBase}-${kind}`;

  return (
    <Button
      className={buttonClassName}
      classes={{ text: `${classNameBase}-label` }}
      disabled={disabled}
      color={kind}
      type={type}
      onClick={onClick}
      variant="contained"
      {...other}
    >
      {children}
    </Button>
  );
}
